import React from 'react';
import { FormattedMessage } from 'react-intl';

export default [
    {
        trackingLabel: 'Trade Program',
        href: '/trade/apply/',
        dataTn: 'footer-designer-program',
        formattedMessage: (
            <FormattedMessage
                id='dbl.Footer.primary_links_trade_program'
                defaultMessage='Trade Program'
            />
        )
    },
    {
        trackingLabel: 'Dealer Application',
        href: '/dealer/application-form/',
        dataTn: 'footer-dealer-application',
        formattedMessage: (
            <FormattedMessage
                id='dbl.Footer.primary_links.dealer_application'
                defaultMessage='Seller Application'
            />
        )
    },
    {
        trackingLabel: 'Dealer Login',
        href: 'https://adminv2.1stdibs.com/login/dealer',
        dataTn: 'footer-dealer-login',
        formattedMessage: (
            <FormattedMessage
                id='dbl.Footer.primary_links_dealer_login'
                defaultMessage='Seller Login'
            />
        )
    },
    {
        trackingLabel: 'Seller Directory',
        href: '/seller-directory/',
        dataTn: 'footer-seller-directory',
        formattedMessage: (
            <FormattedMessage
                id='dbl.Footer.primary_links_seller_directory'
                defaultMessage='Seller Directory'
            />
        )
    }
];



// WEBPACK FOOTER //
// ./src/components/Footer/messages/primaryLinks.jsx